export default __webpack_public_path__ + "static/logo-537ec9e6b979ec815219422b302848c5.svg";